import React from 'react';

import { StyleSheet } from 'react-native';
import type { ViewStyle } from 'react-native';
import { withTypography } from 'ucl/components/text/Typography';

import { Box, BoxProps } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { primitive, shadows, spacing } from 'styles/constants';

export const Container = ({ style, ...props }: BoxProps) => {
  const isDesktop = useIsDesktopBreakpoint();

  return React.createElement(Box, {
    ...props,
    style: [styles.container, isDesktop && styles.containerDesktop, style],
  });
};

export const Header = withTypography({
  variant: 'headerOne',
  fontSize: '3xl',
  style: {},
});

export const OrderNumber = withTypography({ variant: 'copyOne', mb: '$4' });

export const Instructions = withTypography({ variant: 'copyOne', my: '$1' });

const styles = StyleSheet.create({
  container: {
    backgroundColor: 'transparent',
    borderRadius: primitive.$borderRadius,
    padding: spacing.$0,
    position: 'relative',
  },
  containerDesktop: {
    ...shadows.$1,
    backgroundColor: primitive.$white,
    padding: spacing.$6,
  } as ViewStyle,
});
